<template>
  <!--添加支付分组弹窗 -->
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="添加支付分组"
      width="400px"
      @close="closeDialog"
    >
      <el-form
        :model="formData"
        ref="replyForm"
        label-width="80px"
        size="small"
      >
        <el-form-item prop="name" label="分组名称">
          <el-input v-model="formData.name" placeholder="请输入分组名称">
          </el-input>
        </el-form-item>
        <el-form-item prop="weight" label="分组权重">
          <el-input v-model="formData.weight" placeholder="请输入分组名称">
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="closeDialog">取消</el-button>
          <el-button
            v-if="orderStatus != 2"
            type="primary"
            @click="submit"
            :loading="buttonLoading"
            >确定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { getData, delApiData, getApiData, postApiData, patchApiData } from '../../http'
export default {
  props: {
    visible: {//展示标志
      type: Boolean,
      default: false
    },
    value: {//数据
      type: Object,
      default: undefined
    },
    type: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      loading: false,//加载动画
      buttonLoading: false,//按钮加载动画
      formData: {
        name: '',//分组名称
        weight: '',//分组权重
      },
      replyText: '',//回复内容
      orderStatus: 1,//订单状态
    }
  },
  computed: {
    ...mapState({
    }),
    dialogVisible: {
      get() {
        return this.visible
      },
      set() {
      }
    },
    dialogInfo: {
      get() {
        return this.value
      },
      set() {
      }
    },
    dialogType: {
      get() {
        return this.type
      },
      set() {
      }
    },
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        if (this.dialogType != 1) {
          this.formData = this.dialogInfo
        } else {
          this.formData = {
            name: '',//分组名称
            weight: '',//分组权重
          }
        }
      }
    },
  },
  created() {
  },
  methods: {
    submit() {
      // 保存数据
      let params = this.formData
      if (this.dialogType === 1) {
        postApiData('pay_category', params).then((res) => {
          this.$message.success("保存成功！")
          this.$emit('refresh')//刷新数据
          this.closeDialog()//关闭弹窗
        })
      } else {
        patchApiData(`pay_category/${this.formData.id}`, params).then((res) => {
          this.$message.success("保存成功！")
          this.$emit('refresh')//刷新数据
          this.closeDialog()//关闭弹窗
        })
      }
    },
    closeDialog() {
      //关闭弹窗
      this.$emit("close")
    }
  }

}
</script>
<style lang="less" scoped>
</style>